export const colors = [
  {
    handle: 'custom-canine-covers',
    colors: [
      {
        name: 'Black',
        color: 'black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/bk_dply-custom-canine-covers.jpg?v=1672789452'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-econo-plus-seat-protectors_de2_black_main1.jpg?v=1672789284'
          }
        ]
      },
      {
        name: 'Charcoal Black',
        color: 'charcoal-black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ch_dply-custom-canine-covers.jpg?v=1672789452'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-econo-plus-seat-protectors_de2_charcoal-black_main1.jpg?v=1672789283'
          }
        ]
      },
      {
        name: 'Gray',
        color: 'gray',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/gy_dply-custom-canine-covers.jpg?v=1672789452'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-econo-plus-seat-protectors_de2_gray_main1.jpg?v=1672789284'
          }
        ]
      },
      {
        name: 'Misty Gray',
        color: 'misty-gray',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ct_dply-custom-canine-covers.jpg?v=1672789452'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-econo-plus-seat-protectors_de2_misty-gray_main1.jpg?v=1672789284'
          }
        ]
      },
      {
        name: 'Tan',
        color: 'tan',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/tn_dply-custom-canine-covers.jpg?v=1672789452'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-econo-plus-seat-protectors_de2_tan_main1.jpg?v=1672789283'
          }
        ]
      },
      {
        name: 'Taupe',
        color: 'taupe',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/tp_dply-custom-canine-covers.jpg?v=1672789452'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-econo-plus-seat-protectors_de2_taupe_main1.jpg?v=1672789284'
          }
        ]
      },
      {
        name: 'Wet Sand',
        color: 'wet-sand',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/sa_dply-custom-canine-covers.jpg?v=1672789452'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-econo-plus-seat-protectors_de2_wet-sand_main1.jpg?v=1672789283'
          }
        ]
      }
    ]
  },
  {
    handle: 'custom-padded-canine-covers',
    colors: [
      {
        name: 'Black',
        color: 'black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/bk_dply-custom-padded-canine-covers.jpg?v=1672790151'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-custom-rear-seat-protectors_dccp_black_main1.jpg?v=1672790027'
          }
        ]
      },
      {
        name: 'Charcoal Black',
        color: 'charcoal-black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ch_dply-custom-padded-canine-covers.jpg?v=1672790151'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-custom-rear-seat-protectors_dccp_charcoal_main1.jpg?v=1672790026'
          }
        ]
      },
      {
        name: 'Gray',
        color: 'gray',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/gy_dply-custom-padded-canine-covers.jpg?v=1672790151'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-custom-rear-seat-protectors_dccp_gray_main1.jpg?v=1672790026'
          }
        ]
      },
      {
        name: 'Misty Gray',
        color: 'misty-gray',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/ct_dply-custom-padded-canine-covers.jpg?v=1672790151'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-custom-rear-seat-protectors_dccp_misty-gray_main1.jpg?v=1672790026'
          }
        ]
      },
      {
        name: 'Tan',
        color: 'tan',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/tn_dply-custom-padded-canine-covers.jpg?v=1672790151'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-custom-rear-seat-protectors_dccp_tan_main1.jpg?v=1672790026'
          }
        ]
      },
      {
        name: 'Taupe',
        color: 'taupe',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/tp_dply-custom-padded-canine-covers.jpg?v=1672790151'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-custom-rear-seat-protectors_dccp_taupe_main1.jpg?v=1672790026'
          }
        ]
      },
      {
        name: 'Wet Sand',
        color: 'wet-sand',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/sa_dply-custom-padded-canine-covers.jpg?v=1672790151'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-custom-rear-seat-protectors_dccp_wet-sand_main1.jpg?v=1672790026'
          }
        ]
      }
    ]
  },
  {
    handle: 'custom-canine-back-seat-bed',
    colors: [
      {
        name: 'Black',
        color: 'black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-dog-bed-bk_dply.jpg?v=1682404942'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-back-seat-dog-beds_dbs_black_main1_a9f389b7-bd6d-4d71-9e3e-b5e1258024b0.jpg?v=1682404682'
          }
        ]
      },
      {
        name: 'Charcoal Black',
        color: 'charcoal-black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-dog-bed-ch_dply.jpg?v=1682404941'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-back-seat-dog-beds_dbs_charcoal_main1_0e92db3e-0aea-4453-a37c-e58c79d86eaa.jpg?v=1682404682'
          }
        ]
      },
      {
        name: 'Taupe',
        color: 'taupe',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-dog-bed-tp_dply.jpg?v=1682404941'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-back-seat-dog-beds_dbs_taupe_main1_be968da1-1b1f-4b35-9cb8-24484a198abb.jpg?v=1682404682'
          }
        ]
      },
      {
        name: 'Gray',
        color: 'gray',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-dog-bed-gy_dply.jpg?v=1682404941'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-back-seat-dog-beds_dbs_gray_main1_6db9bbcf-16b6-48c3-bd80-d35987c1528a.jpg?v=1682404682'
          }
        ]
      },
      {
        name: 'Misty Gray',
        color: 'misty-gray',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-dog-bed-ct_dply.jpg?v=1682404941'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-back-seat-dog-beds_dbs_misty-gray_main1_33e116a5-4a9d-478f-af5d-f5f5bcbeebdd.jpg?v=1682404682'
          }
        ]
      },
      {
        name: 'Tan',
        color: 'tan',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-dog-bed-tn_dply.jpg?v=1682404941'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-back-seat-dog-beds_dbs_tan_main1_cb26442b-8b0b-43f4-833a-9b4ef9ae632e.jpg?v=1682404682'
          }
        ]
      },
      {
        name: 'Wet Sand',
        color: 'wet-sand',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-dog-bed-sa_dply.jpg?v=1682404941'
          },
          {
            type: 'main',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/canine-covers-back-seat-dog-beds_dbs_wet-sand_main1_ad43c254-c4a1-4e6c-8bbe-5699cb75cdb3.jpg?v=1682404682'
          }
        ]
      }
    ]
  }
]